import axios from 'axios'
import { config } from '../constants'

const BASE_URL_GEMVISION = `${config.BASE_URL}/gemvision`
const ROOT_URL_PUT_REQUEST_DATA = `${BASE_URL_GEMVISION}/requestData`

export const getNameWithCode = (code, jsonData) => {
  if (!code) return undefined
  code = code.toLowerCase()
  const foundName = jsonData.find((element) => element.value.toLowerCase() === code)
  if (!foundName) {
    console.warn(`Code not found ${code}`)
    return undefined
  }
  return foundName.text
}

export const RequestData = async (data) => {
  try {
    await axios.put(ROOT_URL_PUT_REQUEST_DATA, data)
    return Promise.resolve('success')
  } catch (error) {
    let response
    if (error.response?.data?.message) {
      response = error.response.data.message
    } else {
      response = error
    }
    console.error(response)
    return Promise.reject(response)
  }
}

export const getApiKey = async (parameterName) => {
  try {
    const key = await axios.post(`${BASE_URL_GEMVISION}/recaptcha`, { parameterName })
    return key.data
  } catch (error) {
    console.error(error.message)
  }
}
